module.exports = __webpack_public_path__ + "static/media/tray-manual-import1.c366e15b.png";